/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    height: '85vh',
  },
  passwordPolicyWrapper: {
    height: '100%'
  },
  passwordPolicies: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  passwordPoliciesHeader: {
    height: '48px',
    fontSize: Tokens.spacing['$sp-4'],
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    padding: Tokens.spacing['$sp-3'],
    boxSizing: 'border-box'
  },
  passwordPoliciesTools: {
    height: '48px',
    padding: theme.spacing(0, 1.5),
  },
  searchBarWrap: {
    width: Tokens.spacing['$sp-80'],
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3'],
  },
  searchField: {
    // borderBottomStyle: 'solid',
    // borderBottomWidth: Tokens.spacing['$sp-0-25'],
    // borderBottomColor: theme.palette.text.secondary
  },
  addPolicyButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  closeButton: {
    position: 'absolute',
    right: Tokens.spacing['$sp-2'],
    top: Tokens.spacing['$sp-2'],
    // color: theme.palette.grey[500]
  },
  spaces: {
    marginTop: '10px',
    marginBottom: '10px'
  },
  sectionTitle: {
    fontWeight: 500,
    marginTop: '20px',
    marginBottom: '10px'
  },
  sectionDescription: {
    // color: 'rgba(44, 50, 62, 0.74)!important',
    fontWeight: 400,
    marginTop: Tokens.spacing['$sp-2'],
    marginBottom: Tokens.spacing['$sp-2'],
  },
  buttonReset: {
    fontSize: '12px',
    fontWeight: 500,
    border: '1px solid #B8B8B8',
  },
  buttonResetLength: {
    alignSelf: 'end'
  },
  buttonResetConsecutiveLetters: {
    alignSelf: 'end'
  },
  checkBoxLabel: {
    display: 'inline-block'
  },
  checkBoxLabelDescription: {
    display: 'inline-block',
    fontSize: '11px'
  },
  divider: {
    marginTop: Tokens.spacing['$sp-6'],
    marginBottom: Tokens.spacing['$sp-6']
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: Tokens.spacing['$sp-4'],
    padding: Tokens.spacing['$sp-4'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.byBlue['50'],
    border: `1px solid ${theme.palette.primary.main}`,
  },
  bellIcon: {
    marginRight: 10,
    color: theme.palette.primary.main,
  },
  loader: {
    backgroundColor: theme.palette.background.paper,
    marginTop: Tokens.spacing['$sp-1'],
    borderRadius: Tokens.spacing['$sp-1-5'],
    height: '100%',
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    padding: Tokens.spacing['$sp-3']
  },
}));
